var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dean-header-mobile-toggle"},[_c('div',{staticClass:"dean-header-mobile-toggle-content"},[_c('dean-icon',{staticClass:"dean-header-mobile-toggle-content-icon",attrs:{"glyph":_vm.icon,"width":25,"height":25}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }